import React from 'react';

class Forbidden extends React.Component {
	render() {
		return (
			<div className="login-box">
				<div className="login-logo">
					<img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
				</div>
				<div className="login-body">
					<p className="error">
						Oh dear. Looks like you've tried to access something you no longer have permission to.
					</p>
					<div className="mt20">
						<button className="btn btn-primary" onClick={this.props.history.goBack}>
							<i className="fa fa-arrow-left mr5" />
							Back
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forbidden;
